<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-compass fa-lg icon-button"
                title="Atualizar movimento"
                @click.stop="abrirModal()"
            ></i>
        </span>
    <b-modal
        v-model="mostrarModal"
        @hidden="fecharModal()"
    >
        <div slot="modal-title">
            Atualizar Movimento - {{comprometimento.vcTipoMovimento}}
        </div>
        <b-col sm="12">
            <b-form-group>
                <label>Movimentos</label>
                <b-form-select
                    :options="tiposMovimentos"
                    v-model="novoMovimento"
                    text-field="codMov"
                    value-field="codMov"
                ></b-form-select>
            </b-form-group>
        </b-col>
        <div slot="modal-footer">
            <b-button
                variant="secondary"
                @click.stop="fecharModal()"
                class="mr-2"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                :disabled="!novoMovimentoValido"
                >Salvar</b-button
            >
        </div>
    </b-modal>
    </div>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    props: {
        erros: {
            type: Array,
            default: () => []
        },

        comprometimento: {
            type: Object
        },

        contrato: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            size1: "130",
            tiposMovimentos: [],
            novoMovimento: '',
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.novoMovimento = ''
        },

        abrirModal() {
            this.mostrarModal = true
            this.novoMovimento = this.comprometimento.vcTipoMovimento
            this.obterTiposMovimentos()
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Atualização de movimento',
                html: `Confirma a atualização do movimento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar(){ 
            this.$store.dispatch('addRequest')
            ComprometimentosServicos.atualizarMovimento({
                IdComprometimento: this.comprometimento.idComprometimentoRequisicao != null ?
                    this.comprometimento.idComprometimentoRequisicao : this.comprometimento.idComprometimento, 
                novoMovimento: this.novoMovimento
            }).then((response) => {
                if (response) {
                    if (response.success){
                        this.$toast.success(
                            'Atualizacao realizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarComprometimento')
                    } else {
                        this.$toast.error(
                            'Erro ao atualizar movimento',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
            })
            this.fecharModal()
            this.$store.dispatch('removeRequest')
        },

        obterTiposMovimentos() {
            this.$store.dispatch('addRequest')
            ComprometimentosServicos.obterTiposMovimentos(this.contrato.idContrato).then((response) => {
                if (response) {
                    if (response.success){
                        this.tiposMovimentos = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
            })

            this.$store.dispatch('removeRequest')
        }
    },

    computed: {
        novoMovimentoValido(){
            if (this.novoMovimento != '' && this.novoMovimento != this.comprometimento.vcTipoMovimento) {
                return true
            }
            return false
        }
    },

    created() {
    }   
}
</script>
